import { RADAR_AXES } from '../../../mocks/radarNormalization';
import { LuminaireAnalytics } from '../../../types/analytics';

interface MetricTableProps {
  slotA: { label: string; color: string; analytics: LuminaireAnalytics } | null;
  slotB: { label: string; color: string; analytics: LuminaireAnalytics } | null;
}

export const MetricTable = ({ slotA, slotB }: MetricTableProps) => {
  return (
    <div className="rounded-xl border border-greyP4 bg-blackP1/40 overflow-hidden">
      <div className="px-4 py-3 border-b border-greyP4">
        <h3 className="text-white font-semibold text-sm">Side-by-side metrics</h3>
      </div>
      <table className="w-full text-xs">
        <thead>
          <tr className="bg-greyP5/60">
            <th className="px-4 py-2 text-left font-medium text-greyP2">Metric</th>
            <th className="px-2 py-2 text-right font-medium">
              <span className="inline-flex items-center justify-center w-5 h-5 rounded bg-green01 text-black text-[10px] font-bold">
                A
              </span>
            </th>
            <th className="px-2 py-2 text-right font-medium">
              <span className="inline-flex items-center justify-center w-5 h-5 rounded border-2 border-green01 text-green01 text-[10px] font-bold">
                B
              </span>
            </th>
            <th className="px-3 py-2 text-right font-medium text-greyP2">Δ</th>
          </tr>
        </thead>
        <tbody>
          {RADAR_AXES.map((axis) => {
            const aRaw = slotA ? axis.rawValue(slotA.analytics) : null;
            const bRaw = slotB ? axis.rawValue(slotB.analytics) : null;
            const delta = aRaw !== null && bRaw !== null ? aRaw - bRaw : null;
            // For "optimal gap" (inverted), positive raw delta means A is WORSE — flip color logic
            const aBetter = delta === null ? null : axis.inverted ? delta < 0 : delta > 0;
            const tied = delta !== null && Math.abs(delta) < 0.5;
            // green = A wins, dim white = B wins, grey = tie — staying inside the green-only palette
            const color = tied ? '#747474' : aBetter ? '#B3EC49' : '#B3B3B3';

            return (
              <tr key={axis.key} className="border-t border-greyP4/60 hover:bg-greyP5/40">
                <td className="px-4 py-2 text-greyP1">{axis.label}</td>
                <td className="px-2 py-2 text-right text-white font-semibold">
                  {aRaw !== null ? axis.format(aRaw) : '—'}
                </td>
                <td className="px-2 py-2 text-right text-white font-semibold">
                  {bRaw !== null ? axis.format(bRaw) : '—'}
                </td>
                <td className="px-3 py-2 text-right font-bold" style={{ color }}>
                  {delta === null ? '—' : tied ? '≈' : `${delta > 0 ? '+' : ''}${delta.toFixed(1)}`}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
